import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const resetSectionMutation = gql`
  mutation ResetSection(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $section: String!
    $userId: String!
    $reason: String
  ) {
    resetSection(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      section: $section
      userId: $userId
      reason: $reason
    )
  }
`

export enum ResetableSection {
  Residential = 'residential',
  Income = 'income',
  Credit = 'credit',
  Identity = 'identity',
  All = 'all',
}

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  section: ResetableSection
  userId?: string
  reason?: string
}

export type ResetSectionData = {
  resetSection: string | unknown
}

export const useResetSectionMutation: WrappedMutation<
  ResetSectionData,
  MutationVars
> = () =>
  useMutation<ResetSectionData, MutationVars>(resetSectionMutation, {
    client: agentClient,
  })
